import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useCloudContext } from '../contexts/CloudProvider.jsx'
import TopNavigation from './TopNavigation.jsx'
import LeftNavigation from './LeftNavigation.jsx'
import '../styles/enhanced-ui.css'

/**
 * Main layout component implementing progressive UI design
 * - Top navigation: Global controls and device context
 * - Left navigation: Device-specific tools (contextual visibility) 
 * - Main content area: Current page content with optimized rendering
 * 
 * The left navigation determines its own width, and main content automatically adjusts
 */
function Layout({ children }) {
  const { hasDevices, isFleetView } = useCloudContext()
  const { pathname } = useLocation()
  
  // Memoize navigation visibility to prevent re-renders
  const showLeftNav = useMemo(() => 
    hasDevices && !pathname.includes('/login') && !isFleetView,
    [hasDevices, pathname, isFleetView],
  )
  
  return (
    <div className="app-layout-enhanced vh-100 d-flex flex-column">
      <TopNavigation />
      
      <div className="flex-grow-1 d-flex">
        {showLeftNav && (
          <div className="bg-light border-end">
            <LeftNavigation />
          </div>
        )}
        
        <div className="flex-grow-1 overflow-auto">
          <main className="main-content-enhanced fade-in-enhanced">
            {children}
          </main>
        </div>
      </div>
    </div>
  )
}

export default Layout
